export function scrollIntoView() {
	document.addEventListener("DOMContentLoaded", () => {
		document.querySelectorAll("[data-scroll]").forEach((button) => {
			button.addEventListener("click", () =>
				document.getElementById(button.dataset.scroll).scrollIntoView(),
			);
		});
	});
}
